var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language"},[_c('span',{staticClass:"language-title",on:{"click":function($event){return _vm.selectLanguage()}}},[_vm._v("\n    言語 Language\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }